// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__29E2c","tab":"ProcedureTabs_tab__2q7Ee"};